import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["href"]

import {computed} from "vue";
import {NavigationAction} from "../../Port/NavigationService.js";
import {useNavigationService} from "../vue";

interface Emit {
  (event: 'action', action: NavigationAction): void;
}

interface Props {
  action: NavigationAction;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'NavigationLink',
  props: {
    action: {}
  },
  emits: ['action'],
  setup(__props: any, { emit: __emit }) {


const props = __props;
const emit = __emit;

const service = useNavigationService();

const href = computed<string|null>(() => service.actionHref(props.action));

function hrefClick(event: MouseEvent): void {
  if (!openInNewTab(event)) {
    invokeAction();
    event.preventDefault();
  }
}

function invokeAction(): void {
  emit('action', props.action);
}

function openInNewTab(event: MouseEvent): boolean {
  return event.ctrlKey || event.metaKey;
}

return (_ctx: any,_cache: any) => {
  return (href.value)
    ? (_openBlock(), _createElementBlock("a", {
        key: 0,
        onClick: hrefClick,
        href: href.value
      }, [
        _renderSlot(_ctx.$slots, "default")
      ], 8 /* PROPS */, _hoisted_1))
    : (_openBlock(), _createElementBlock("span", {
        key: 1,
        onClick: invokeAction
      }, [
        _renderSlot(_ctx.$slots, "default")
      ]))
}
}

})